import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const q = searchParams.get('q') || '';
    const section = searchParams.get('section') || 'All';
    const category = searchParams.get('category') || 'All';
    const sort = searchParams.get('sort') || 'latest';
    const page = searchParams.get('page') || '1';

    const newParams = new URLSearchParams();
    if (q) newParams.set('search', q);
    if (section && section !== 'All') newParams.set('section', section);
    if (category && category !== 'All') newParams.set('category', category);
    if (sort && sort !== 'latest') newParams.set('sort', sort);
    if (page && page !== '1') newParams.set('page', page);

    navigate(`/shop?${newParams.toString()}`, { replace: true });
  }, [searchParams, navigate]);

  return (
    <div className="shop-page-body" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div className="dropdown-loading" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div className="spinner" style={{
          width: '32px',
          height: '32px',
          border: '2px solid rgba(255, 255, 255, 0.1)',
          borderTopColor: '#a06e3f',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }}></div>
        <span style={{ color: 'var(--color-text-muted)', fontSize: '14px', marginTop: '16px', fontWeight: '500' }}>Redirecting to catalog...</span>
      </div>
    </div>
  );
};

export default SearchPage;
